import { useRef } from 'react'

import { useUsRestrictedDataAccess } from './useUsRestrictedDataAccess'

/**
 * `useUsRestrictedDataAccess`, but a failed background refresh of the ability
 * keeps the last answer instead of flipping to "no access" (EMS-10967). Use it
 * to hide whole surfaces (e.g. the Open Enrollment People tab), so a
 * transient /me/ability error doesn't yank them from a cleared user
 * mid-session.
 *
 * Still fails closed: no access while the ability first loads, and when it has
 * never loaded successfully. UI only — the EPS guard is the real boundary.
 */
export function useStableUsRestrictedDataAccess(): {
  hasUsRestrictedDataAccess: boolean
  isLoading: boolean
} {
  const { hasUsRestrictedDataAccess, isLoading, isError } =
    useUsRestrictedDataAccess()
  const lastKnownAccess = useRef<boolean | null>(null)

  if (!isLoading && !isError) {
    lastKnownAccess.current = hasUsRestrictedDataAccess
  }

  return {
    hasUsRestrictedDataAccess: isError
      ? (lastKnownAccess.current ?? false)
      : hasUsRestrictedDataAccess,
    isLoading,
  }
}
